import React, {useContext, useEffect, useState} from 'react';
import Api from '../../../../interface/api/visit';
import SiteApi from '../../../../interface/api/site';
import {Pagination} from "../../../../component/paging";
import {Page} from "../../../../interface/model/page";
import {Search1} from "../../../../component/search";
import {HostStateContext} from "../../index";
import {convertDate} from "../../../../util/convertDate";

import { makeStyles } from '@material-ui/core/styles';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import {dateConvert} from "../index";

const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: '1px solid #e1e1e1',
        },
    },
});

function getDefaultSiteInfoSeq() {
    try {
        const hostInfo = JSON.parse(localStorage.getItem('hostInfo') || 'null');
        return hostInfo?.siteInfo?.seq || '';
    } catch (e) {
        return '';
    }
}

export default function VisitorHistory() {
    const { auth, hostInfo } = useContext(HostStateContext);
    const classes = useRowStyles();
    const [open, setOpen] = React.useState({
        index : 0,
        flag : false,
        visitorHistoryInfos : []
    });
    const [visitorList, setVisitorList] = useState<Page>();
    const [ pageNumber, setPageNumber ] = useState<number>(0);
    const [ siteInfoOptions, setSiteInfoOptions ] = useState<Array<any>>([]);
    const today = convertDate(new Date());
    const [ searchInfo , setSearchInfo ] = useState({
        searchToDate : today,
        searchFromDate : today,
        visitorInfoSearchType : 'visitorName',
        searchValue : '',
        siteInfoSeq : getDefaultSiteInfoSeq()
    })

    function getHistoryDetail(visitorInfo) {
        Api.getVisitorHistoryInfoList(visitorInfo.seq).then(res => {
            setOpen({
                ...open,
                index : visitorInfo.seq,
                flag : !open.flag,
                visitorHistoryInfos : res.data
            })
        });
    }

    function excelDownload() {
        let hostInfo = JSON.parse(localStorage.getItem('hostInfo'));
        let searchToDate = searchInfo.searchToDate;
        let searchFromDate = searchInfo.searchFromDate;
        let searchValue = searchInfo.searchValue;
        let visitorInfoSearchType = searchInfo.visitorInfoSearchType;
        let siteInfoSeq = searchInfo.siteInfoSeq;
        window.location.href=`/v1/visit-info/excel/download?hostInfoSeq=${hostInfo.number}&searchToDate=${searchToDate}&searchFromDate=${searchFromDate}&searchValue=${searchValue}&visitorInfoSearchType=${visitorInfoSearchType}&siteInfoSeq=${siteInfoSeq}`;
    }

    function pageMoveHandler(pageNumber) {
        let hostInfo = JSON.parse(localStorage.getItem('hostInfo'));
        Api.getVisitorInfoListBySearchAndPage(hostInfo.number, searchInfo, pageNumber).then(res => setVisitorList(res.data));
    }

    function searchHandler() {
        let hostInfo = JSON.parse(localStorage.getItem('hostInfo'));
        Api.getVisitorInfoListBySearchAndPage(hostInfo.number, searchInfo, pageNumber).then(res => setVisitorList(res.data));
    }

    function collectSiteInfosByDepth(siteInfo, targetDepth, result = []) {
        if (!siteInfo) {
            return result;
        }

        if (siteInfo.depth === targetDepth) {
            result.push(siteInfo);
        }
        if (siteInfo.childrenSiteInfos && siteInfo.childrenSiteInfos.length > 0 && siteInfo.depth < targetDepth) {
            siteInfo.childrenSiteInfos.forEach((childSiteInfo) => collectSiteInfosByDepth(childSiteInfo, targetDepth, result));
        }
        return result;
    }

    function getRootSiteInfo(siteInfo) {
        if (!siteInfo || !siteInfo.parentSiteInfo) {
            return siteInfo;
        }

        return getRootSiteInfo(siteInfo.parentSiteInfo);
    }

    useEffect(() => {
        let hostInfo = JSON.parse(localStorage.getItem('hostInfo'));
        Api.getVisitorInfoListBySearchAndPage(hostInfo.number, searchInfo, 0).then(res =>
            setVisitorList(res.data)
        );
        if (auth?.access?.urls && (auth.access.urls.length === 1 || auth.access.urls.length === 6) && hostInfo?.siteInfo?.seq) {
            const rootSiteInfo = getRootSiteInfo(hostInfo.siteInfo);
            SiteApi.siteInfoListBySeq(rootSiteInfo.seq).then(res => {
                setSiteInfoOptions(collectSiteInfosByDepth(res.data, 1));
            });
            return;
        }

        SiteApi.siteInfoList().then(res => {
            const siteInfos = [];
            res.data.forEach((siteInfo) => collectSiteInfosByDepth(siteInfo, 1, siteInfos));
            setSiteInfoOptions(siteInfos);
        });

    }, [auth, hostInfo, today])

    const showSiteInfoOptions = !!auth?.access?.urls && auth.access.urls.length !== 3;

    return (
        <>
            <div className="add">
                <div className="btn_left">
                    <p className="m_tit nv_bold pc_skip tpc_skip m_skip" onClick={excelDownload}>엑셀 다운로드</p>
                    <button type="button" className="nv_green_button down_icon_btn m_skip" onClick={excelDownload}>엑셀 다운로드</button>
                </div>
                <Search1
                    searchHandler={searchHandler}
                    searchInfo={searchInfo}
                    setSearchInfo={setSearchInfo}
                    siteInfoOptions={siteInfoOptions}
                    showSiteInfoOptions={showSiteInfoOptions}
                />
                <div className="nv_table_box adminVersion">
                    <TableContainer component={Paper}>
                        <table className={"nv_table"} aria-label="a dense table">
                            <thead>
                                <tr>
                                    <th align="center">방문자</th>
                                    <th align="center" className="m_skip">업체명</th>
                                    <th align="center" className="m_skip">연락처</th>
                                    <th align="center" className="m_skip">차량번호</th>
                                    <th align="center" className="m_skip">방문증번호</th>
                                    <th align="center">입문일시</th>
                                    <th align="center" className="m_skip">퇴문일시</th>
                                    <th align="center">접견인</th>
                                    <th align="center" className="m_skip">방문목적</th>
                                    <th align="center" className="m_skip">방문위치</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    visitorList!==undefined && visitorList.content.length > 0 ?
                                        visitorList.content.map((visitor, index) => (
                                        <>
                                            <tr className={classes.root}>
                                                <td align="center">
                                                    {
                                                        visitor.vipFlag !== null && visitor.vipFlag === true
                                                            ?
                                                                visitor.visitorHealthCheckupDate !== undefined && visitor.visitorHealthCheckupDate !== ""
                                                                ?
                                                                    '[VIP] ' + visitor.visitorName + "(" + visitor.visitorHealthCheckupDate + ")"
                                                                :
                                                                    '[VIP] ' + visitor.visitorName
                                                            :
                                                                visitor.visitorHealthCheckupDate !== undefined && visitor.visitorHealthCheckupDate !== ""
                                                                ?
                                                                    visitor.visitorName + "(" + visitor.visitorHealthCheckupDate + ")"
                                                                :
                                                                    visitor.visitorName
                                                    }
                                                </td>
                                                <td align="center" className="m_skip">{visitor.visitorCompany}</td>
                                                <td align="center" className="m_skip">{visitor.visitorPhone}</td>
                                                <td align="center" className="m_skip">{visitor.visitorCar}</td>
                                                <td align="center" className="m_skip">{visitor.card}</td>
                                                <td align="center">{`${dateConvert(visitor.visitorCheckInTime)}`}</td>
                                                <td align="center" className="m_skip">
                                                    {visitor.visitorCheckOutTime!=null ? `${dateConvert(visitor.visitorCheckOutTime)}` : `-`}
                                                </td>
                                                <td align="center">{visitor.hostName}</td>
                                                <td align="center" className="m_skip">{visitor.visitorPurpose}</td>
                                                <td align="center" className="m_skip">{visitor.visitorLocation}</td>
                                            </tr>
                                        </>
                                    )) :
                                        <tr>
                                            <td colSpan={10} align="center">등록된 방문 이력이 없습니다.</td>
                                        </tr>
                                }
                            </tbody>
                        </table>
                    </TableContainer>
                    <Pagination page={visitorList} pageMoveHandler={pageMoveHandler} />
                </div>
            </div>
        </>
    )
}
